export class SearchComplianceProposalQueryModel {
  startDate: string;
  endDate: string;
  institution: string;
  serviceContract: string;
  cpfCnpj: string;
  statusComplianceIdParam: string;
}
